import React from 'react';
import { RicosViewerLazy } from '../../loadable';
import { getHeaderAndParagraphCustomStyles } from '../../loadable/ricos-viewer/theme-utils';
import { classes } from './submit-button.st.css';
import { Transition as ReactTransition } from 'react-transition-group';
const DURATION = 350;
const defaultStyle = {
  transition: `opacity ${DURATION}ms ease-in-out`,
  opacity: 0
};
const transitionStyles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  },
  exited: {
    opacity: 0
  }
};
const RICOS_THEME = {
  customStyles: getHeaderAndParagraphCustomStyles()
};
const ThankYouMessage = _ref => {
  let {
    messageText,
    showMessage
  } = _ref;
  if (!messageText) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ReactTransition, {
    in: showMessage,
    timeout: DURATION
  }, state => /*#__PURE__*/React.createElement("div", {
    style: {
      ...defaultStyle,
      ...transitionStyles[state]
    },
    "data-hook": "thank-you-message"
  }, showMessage && /*#__PURE__*/React.createElement(RicosViewerLazy, {
    content: messageText,
    customTheme: RICOS_THEME,
    className: classes.thankYouMessage
  })));
};
export default ThankYouMessage;
//# sourceMappingURL=thank-you-message.js.map